export default {
    baseURL: process.env.VUE_APP_API_BASE_URL,
    endpoints: {
        /* Authentication routes */
        login: 'login',
        register: 'register',
        loadUsers: 'login',
        me: 'api/me',
        importFromCsv: 'api/customers/import-from-csv',
        sendMessagesNow: 'api/scenario/{scenario_id}/send-now',
        requestNewPassword: 'api/auth/reset/request',
        exportAllCustomers: 'api/customers/export-all',

        /*
        ** CUSTOMER REGISTRATION
        */

        registerCustomer: 'api/public/customer/registration',
        updateCustomerSegments: 'api/customer/segments',
        updateCustomerData: 'api/customer/update',
        deleteCustomers: 'api/customers/bulkDelete',

        /*
        ** PORTAL
        */

        loadPortalManager: 'api/portal/{establishment_id}/get',
        createPortal: 'api/portal/{establishment_id}/create',
        updatePortal: 'api/portal/{portal_id}/update',
        publicPortal: 'api/public/portal/{establishment_id}',
        publicMenuPortal: 'api/public/portal/menu/{establishment_id}',

        /*
        ** ESTABLISHMENT
        */

        establishment: 'api/establishment/get',
        createEstablishment: 'api/establishment/create',
        updateEstablishment: 'api/establishment/{establishment_id}/update',
        manager: 'api/managerFile/get',
        createManager: 'api/managerFile/create',
        updateManager: 'api/managerFile/{manager_id}/update',
        customer: 'api/customers/get',
        allCustomer: 'api/customers/list',
        createCustomer: 'api/customerFile/create',
        updateCustomer: 'api/customerFile/{customer_id}/update',
        router: 'api/all_router/get',
        idRouter: 'api/router/{id_router}/get',
        createRouter: 'api/router/create',
        updateRouter: 'api/router/{router_id}/update',

        /*
        ** ESTABLISHMENT SCHEDULES
        */

        scheduleEstablishment: 'api/establishment/schedule/{establishment_id}/get',
        createScheduleEstablishment: 'api/establishment/schedule/create',
        updateScheduleEstablishment: 'api/establishment/schedule/update',

        /*
        ** SCENARIO
        */

        scenarios: 'api/scenario/{scenario_id}/get',
        allScenarios: 'api/scenario/list',
        createScenarios: 'api/scenario/create',
        updateScenario: 'api/scenario/{scenario_id}/update',
        activeScenarios: 'api/establishment/{establishment_id}/scenario/kpi',
        deleteScenario: 'api/scenario/{scenario_id}/delete',
        enableScenario: 'api/scenario/{scenario_id}/enable',
        disableScenario: 'api/scenario/{scenario_id}/disable',

        /**
         * SEGMENTS
         */
        segment: 'api/segment/{segment_id}',
        segments: 'api/segment',
        addSegment: 'api/segment',
        updateSegment: 'api/segment/{segment_id}',
        deleteSegment: 'api/segment/{segment_id}',

        /*
        ** PERSONAL_MESSAGE
        */

        // createPersonalMessage : 'api/personalmessage/create',
        loadPersonalMessage: 'api/personalmessage/{establishment_id}/get',
        upsertPersonalMessage: 'api/personalmessage/{establishment_id}/upsert',

        /*
        ** DASHBOARDS
        */

        getDashboardMain: 'api/dashboard/main',
        getDashboardStats: 'api/dashboard/stats',
        getDashboardSmsEmailHistory: 'api/dashboard/smsEmailHistory'

    }

};
